<div class="relative w-24 h-24 grid place-items-center mr-4" [style.--value]="tx()">
  <svg viewBox="0 0 100 100" class="absolute inset-0">
    <defs>
	  <!-- si plusieurs radials sur la page, il faut rendre l'id unique -->
      <linearGradient id="grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#44fffb"/>
        <stop offset="25%" stop-color="#44b0ff"/>
        <stop offset="50%" stop-color="#8b44ff"/>
        <stop offset="75%" stop-color="#ff6644"/>
        <stop offset="100%" stop-color="#ebff70"/>
      </linearGradient>
    </defs>

    <!-- TRACK = % manquant -->
    <circle
      cx="50" cy="50" r="42"
      fill="none"
      stroke="#f2f7fe"
      stroke-width="5"
    />

    <!-- Progress ring -->
    <circle
      cx="50" cy="50" r="42"
      fill="none"
      stroke="url(#grad)"
      stroke-width="5"
      stroke-linecap="round"
      stroke-dasharray="263.89"
      class="progress-ring"
      transform="rotate(-90 50 50)"
    />
  </svg>

  <div class="relative text-primary font-semibold">{{tx()}}%</div>
</div>